module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/guest-list-1d4040f9c05cbe647883dd6ab8572338.webp";